<script lang="ts" setup>
import "@/assets/js/iconfont.js";
const props = defineProps({
  type: {
    type: String,
    default: ''
  }
})
</script>

<template>
  <svg class="iconfont" aria-hidden="true">
    <use :xlink:href="'#' + props.type"></use>
  </svg>
</template>

<style lang="less">
.iconfont {
  width: 1em;
  height: 1em;
  fill: currentColor;
  overflow: hidden;
}
</style>
